
import React, { useEffect } from "react";
import "./AllPosts.css";
import { useGlobalContext } from "../../context";
import { Link } from "react-router-dom"; 

function DayPostsTable({ tableData, setActiveCategory, sortBySocialMedia, setSortBySocialMedia }) {
    
    const {
        categorys,
        setCategorys
    } = useGlobalContext()
    
    const changeActiveCategory = (item) => {
        setCategorys(categorys => categorys.map(ctgry => ctgry.id === item.id ? { ...ctgry, active: true } : { ...ctgry, active: false }));
    }
    
    useEffect(() => {
        const active = categorys.find(item => item.active);
        setActiveCategory(active.text);
    }, [categorys]);

    const dateUpdate = (date) => {
        return new Date(date).toLocaleDateString("en-US",{
            month: "short",
            day: "numeric",
            year: "numeric"
        })
    }
    
    const sortingByMedia = () => {
        if (sortBySocialMedia === false) {
            setSortBySocialMedia(true);
        }
        else if (sortBySocialMedia === true) {
            setSortBySocialMedia();
        }
        else {
            setSortBySocialMedia(false);
        }
    }
    
    return(
        <div className = "AddPostTable">
            <div className = "dayPostTableHeaderBox">
                <h3 
                    className = "usersTableHeaderText" 
                    style = {{
                        margin: "10px 20px"
                    }}
                >
                    POSTS
                </h3>
                <span className = "dayPostTableHeaderDateText">
                    { tableData && tableData.length > 0 ? dateUpdate(tableData[0].creationDate) : "" }
                </span>
            </div>
            <div className = "addPostCategoryFilter">
                {
                    categorys.map(item => item.id !==0 &&
                        <span
                            key = { item.id }
                            className = "addPostCategorySpan"
                            style = {{
                                color: item.active ? "#3F68B1" : "#929292",
                                border: item.active ? "1px solid #3F68B1" : "1px solid #929292"
                            }}
                            onClick = { changeActiveCategory.bind(this, item) }
                        >
                            { item.text }
                        </span>
                    )
                }
            </div>
            <div className = "postsTableBox">
                <div className = "AddPostTableRowBox postTableRowBox">
                    <span className = "postTableFullName addPostHeaderText">FULL NAME</span>
                    <span className = "postTableFbId addPostHeaderText">FACEBOOK ID</span>
                    <span className = "postTableFbId postTableInstaId addPostHeaderText">INSTAGRAM ID</span>
                    <span className = "postTableMetaAcc addPostHeaderText">META ACCOUNT</span>
                    <span className = "postTableStatus addPostHeaderText">STATUS</span>
                    <span 
                        className = "postTableSocialMedia addPostHeaderText" 
                        style = {{
                            cursor: "pointer"
                        }} 
                        onClick = { sortingByMedia }
                    >
                        SOCIAL MEDIA
                    </span>
                </div>
                <div className = "allUsersTableMainBox">
                {
                    tableData && tableData.map((item, index) =>
                        <div className = "AddPostTableRowBox postTableRowBox" key = { index }>
                            <span className = "postTableFullName" style = {{color: "rgba(0,0,0,0.7)"}}>{ item.clientFullName }</span>
                            <span className = "postTableFbId" style = {{color: "rgba(0,0,0,0.7)"}}>{ item.facebookProfileId }</span>
                            <span className = "postTableFbId postTableInstaId" style = {{ color: "rgba(0,0,0,0.7)"}}>{ item.instagramProfileId }</span>
                            <span className = "postTableMetaAcc" style = {{ color: "rgba(0,0,0,0.7)"}}>
                                <Link to = { item.businessLink } target = {"blank"} className = "metaBusinessLink">
                                    { item.businessLink }
                                </Link>
                            </span>
                            <span 
                                className = "postTableStatus" 
                                style = {{
                                    color: item.status === "FAILED" ? "#C52626" : "#359B25",
                                    cursor: item.status === "FAILED" && "pointer",
                                    position: "relative",
                                    overflow: "visible"
                                }}
                            >
                                { item.status }
                                {
                                    item.status === "FAILED" ?
                                        <span className = "postTableHiddenBox">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                        </span>
                                        : null
                                }
                            </span>
                            <span 
                                className = "postTableSocialMedia" 
                                style = {{
                                    color: "rgba(0,0,0,0.7)"
                                }}
                            >
                                { item.socialMedia }
                            </span>
                        </div>
                    )  
                }
                </div>
            </div>
        </div>        
    )
}

export default DayPostsTable
